import React, { useEffect } from "react";
import HomePageHero from "../Home/HomePageHero";
// import HomePartners from "../Home/HomePartners";
import HomeAbout from "../Home/HomeAbout";
// import HomeStats from "../Home/HomeStats";
// import HomeCategory from "../Home/HomeCategory";
// import HomeCources from "../Home/HomeCources";
// import HomeWhyChoose from "../Home/HomeWhyChoose";
import HomeTeamMember from "../Home/HomeTeamMember";
import HomeMission from "../Home/HomeMission";
import HomeContact from "../Home/HomeContact";
import HomeProjects from "../Home/HomeProjects";

const HomePage = () => {
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const sectionId = hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
  return (
    <>
      <title>Welcome to SLN Educational Society</title>
      <div className="xl:max-w-screen-xl w-11/12 mx-auto">
        <HomePageHero />
        {/* <HomePartners /> */}
        <HomeAbout />
        {/* <HomeStats /> */}
      </div>
      <HomeTeamMember />
      {/* <HomeCategory />  */}
      {/* <HomeCources /> */}
      {/* <HomeWhyChoose /> */}
      <HomeMission />
     
      <HomeContact />
        <HomeProjects/>
    </>
  );
};

export default HomePage;
